import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MetalRateStrip from '../components/MetalRateStrip';
import './BlogLogin.css';

const BlogLogin = () => {
  const navigate = useNavigate();
  const [authorEmail, setAuthorEmail] = useState('');
  const [passkey, setPasskey] = useState('');
  const [authorName, setAuthorName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');

    if (!authorEmail.trim() || !passkey.trim()) {
      setError('Please provide your Author Email and Editorial Passkey.');
      return;
    }

    setLoading(true);

    // Dedicated author portal authentication
    // Default master passkey or custom author passkey
    setTimeout(() => {
      if (passkey === 'jmi2026' || passkey === 'author@jmi' || passkey.length >= 6) {
        const authorSession = {
          email: authorEmail.trim(),
          name: authorName.trim() || authorEmail.split('@')[0] || 'Editorial Contributor',
          role: 'Accredited Bullion Analyst & Author',
          token: `AUTH-${Date.now()}`,
          loggedInAt: new Date().toISOString(),
        };
        sessionStorage.setItem('jmi_blog_author', JSON.stringify(authorSession));
        navigate('/blog-portal/dashboard');
      } else {
        setError('Invalid Editorial Passkey. Passkey must be at least 6 characters (e.g., jmi2026).');
      }
      setLoading(false);
    }, 400);
  };

  return (
    <div className="app-wrapper blog-login-wrapper">
      <MetalRateStrip />
      <Navbar />

      <main className="blog-login-main">
        <div className="jmi-container">
          <div className="blog-login-card">
            <div className="login-header-zone">
              <div className="author-icon-badge">✍️</div>
              <div className="portal-tag">DEDICATED EDITORIAL DESK</div>
              <h2>JMI Blog Author & Analyst Portal</h2>
              <p>
                Separate publishing gateway strictly for JMI bullion research contributors, 
                regulatory analysts, and market journalists.
              </p>
            </div>

            <div className="portal-separation-notice">
              🔒 <strong>Notice:</strong> This portal is solely for authoring and publishing blog articles. 
              Retailers and manufacturers seeking B2B app access must apply via the <Link to="/apply">Onboarding Application</Link>.
            </div>

            {error && <div className="login-error-alert">⚠️ {error}</div>}

            <form onSubmit={handleLogin} className="blog-login-form">
              <div className="form-group">
                <label>Author / Contributor Name</label>
                <input
                  type="text"
                  placeholder="e.g. Devendra Soni / JMI Research Desk"
                  value={authorName}
                  onChange={(e) => setAuthorName(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Registered Editorial Email *</label>
                <input
                  type="email"
                  placeholder="author@jewelmartindia.com"
                  value={authorEmail}
                  onChange={(e) => setAuthorEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Editorial Access Passkey *</label>
                <input
                  type="password"
                  placeholder="Enter editorial passkey (default: jmi2026)"
                  value={passkey}
                  onChange={(e) => setPasskey(e.target.value)}
                  required
                />
                <span className="field-tip">Editorial passkey: <code>jmi2026</code></span>
              </div>

              <button type="submit" disabled={loading} className="btn btn-primary btn-lg w-full">
                {loading ? 'Authenticating Author Session...' : 'Sign In to Author Publishing Studio →'}
              </button>
            </form>

            <div className="login-card-footer">
              <Link to="/blog">← Return to Public Blog</Link>
              <span>•</span>
              <Link to="/">Platform Home</Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default BlogLogin;
